export const ENDPOINT = 'api/app/addresses';

export type UserAddress = {
  id: string; // 123
  street: string; // R. João Miranda Costa
  number: string; // 120
  complement: string; // Apto 301
  reference?: string; // Próximo ao CMEI Regional São Lourenço
  district: string; // Vista Da Serra I
  city: string; // Serra
  state: string; // ES
  cep: string; // 29176-000
  coordinates: {
    latitude: number; // -20.197512
    longitude: number; // -40.234981
  };
};

export type UserAddressRequest = Omit<UserAddress, 'id' | 'coordinates'> & {
  latitude: string; // -20.197512
  longitude: string; // -40.23498
  is_manual?: boolean; // true quando endereço digitado manualmente sem coordenadas
};
